function serializeOccupancy(occupancy) {
  const { adult, children } = occupancy;

  return `${adult}${children.length ? `-${children.join(',')}` : ''}`;
}

export default serializeOccupancy;
